import { defineComponent as _defineComponent } from 'vue'
import { useInvoices } from '@/store/useInvoices';
import { useUserspace } from '@/store/useUsers';
import { useDogspace } from '@/store/dogspaces';
import moment from "moment";
import InvoiceTransactions from '../components/invoice-transactions.vue';
import { ref, computed, onMounted } from 'vue';
// import { DataInstance } from '@busy-human/gearbox';
// import { Userspaces } from '@busy-human/k9-library';

import { Temporal } from 'temporal-polyfill';


export default /*@__PURE__*/_defineComponent({
  __name: 'transactions-table',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserspace();
const dogStore = useDogspace();

function getDogName (dogId: any){
	console.log(dogId);
	let dogInfo = "";
	let dog;

	if (dogId in dogStore.dogs) {

		dog = dogStore.dogs[dogId];
		dogInfo = String(dog.name);

	}

	return dogInfo;
	// {{ dogStore.dogs[invoice.dogId]?.name.fullName || "Unknown" }}

}

const invoiceStore = useInvoices();
const invOpenSet = ref(new Set<string>());

onMounted(() => {
	invoiceStore.fetchAllInvoices();
	console.log(invoiceStore);
});

const startDate = ref("");
const endDate = ref("");
const searchQuery = ref("");

function dateparse(str: string) {
	if(!str) return null;
	try {
		return Temporal.PlainDate.from(str);
	} catch (e) {
		console.error(e);
		return null;
	}
}

const filteredResults = computed(() => {
	const query = searchQuery.value.toLowerCase();
	const startVal = dateparse(startDate.value);
	const endVal = dateparse(endDate.value);

	return invoiceStore.asArray.filter(invoice => {
		if(invoice.dueAt && (startVal || endVal)) {
			const invDue = Temporal.PlainDate.from(invoice.dueAt.substring(0, invoice.dueAt.indexOf("T")));
			if(startVal && Temporal.PlainDate.compare(startVal, invDue) > 0) return false;
			if(endVal && Temporal.PlainDate.compare(endVal, invDue) < 0) return false;

		} else if((startVal || endVal) && !invoice.dueAt) {
			console.log("%c *** !invoice.dueAt", "color:aqua;border:aqua;background:black;", startVal,endVal,invoice.dueAt);
			return false;
		}

		if(searchQuery.value) {
			const custName = (userStore.users[invoice.userId]?.name.fullName || "Unknown").toLowerCase();
			if(!custName.includes(query)){
				console.log("%c Customer name is not available ", "color:#ff8800;border:#ff8800;background:black;", query);
				return false;
			}
		}
		console.log("%c Invoice", "color:#88ff00;border:#88ff00;background:black;", invoice);
		return true;
	}).sort((a, b) => b.invoiceId.localeCompare(a.invoiceId));
});

const __returned__ = { userStore, dogStore, getDogName, invoiceStore, invOpenSet, startDate, endDate, searchQuery, dateparse, filteredResults, get useInvoices() { return useInvoices }, get useUserspace() { return useUserspace }, get useDogspace() { return useDogspace }, get moment() { return moment }, InvoiceTransactions, ref, computed, onMounted, get Temporal() { return Temporal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})